import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ToastProvider } from "./hooks/useToast";
import { ThemeProvider } from "./hooks/useTheme";
import { UaCalendarLayer } from "./components/base/UaCalendar";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ToastProvider>
        <ThemeProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <AppRoutes />
          </BrowserRouter>
          {/* Український календар для всіх полів дати. Один шар на програму:
              нативний пікер Chromium бере мову з інтерфейсу браузера, тож на
              російському Chrome він відкривався російською — перебити це можна
              лише власним пікером. Шар живе поза Router, бо не залежить від
              маршруту. */}
          <UaCalendarLayer />
        </ThemeProvider>
      </ToastProvider>
    </I18nextProvider>
  );
}

export default App;
